export default __webpack_public_path__ + "static/media/dark_icon.1144ed8d.svg";